<template>
    <div>
        <!-- User Interface controls -->
        <b-row>
            <b-col md="7" class="my-1">
                <b-form-group class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" />
                        <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="5" class="my-1">
                <b-form-group label-cols="4" label="Per page" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form-group>
            </b-col>
        </b-row>

        <!-- Main table element -->
        <b-table 
        show-empty 
        empty-text="Please wait while the competencies load.  If you have completed all comptencies don't wait long!" 
        striped 
        responsive 
        stacked="md" 
        :items="items" 
        :fields="fields" 
        :current-page="currentPage" 
        :per-page="perPage"
        :filter="filter" 
        @filtered="onFiltered"
        >
            <template v-slot:cell(title)="row">
              {{ row.item.title }}
               <div v-if="row.item.laboratory == 1"><small class="text-success">Can be simulated</small></div>
            </template>
            <template v-slot:cell(actions)="row" class="text-nowrap">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <!-- <b-button-group> -->
                    <b-button @click.stop="row.toggleDetails" class="btn btn-success mb-2">
                        <span class="icon icon-eye"> Details</span>
                    </b-button>
                    <b-button @click="addAttempt(row.item.id)" class="btn btn-primary mb-2">
                        <span class="icon icon-plus"> Performed</span>
                    </b-button>
                <!-- </b-button-group> -->
            </template>
            <template v-slot:row-details="row">
                <b-card>
                    <div v-html="row.item.description">
                    </div>
                    <p>The benchmark for this competency is: {{ row.item.benchmark }}</p>
                    <p>The number of times you must achieve this score is: {{ row.item.num_skills_required }}</p>
                </b-card>
            </template>
        </b-table>

        <b-row>
            <b-col md="12" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
            </b-col>
        </b-row>

    </div>
</template>

<script>
import swal from 'sweetalert';
const items = [];

export default {
  props: ['ped_competencies'],
  data() {
    return {
      items: this.ped_competencies,
      fields: [
        { key: "category", label: "Area", sortable: true, class: 'tcol'},
        { key: "title", label: "Competency", sortable: true, class: 'tcol2' },
        { key: "actions", label: "Actions" }
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: this.ped_competencies.length,
      pageOptions: [15, 25, 35, 50],
      filter: null,
      modalInfo: { title: "", content: "" }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    addAttempt(id) {
      axios.get('/competency/add/' + id)
            .catch(function (error) {
                // handle error
                console.log(error);
            });
        swal("Good Job!", "You logged this competency", {
  buttons: {
    cancel: "Close",
    now: "Visit Log"
  },
}).then(now => {
  if (now) {
    window.location.href = ('/competency/unsent/');
  }
});
    }
  },
  // mounted() {
  //   axios
  //     .get("/competency/ped")
  //     .then(response => (this.items = response.data))
  //     .catch(function(error) {
  //       // handle error
  //       console.log(error);
  //     });
  // }
};
</script>

<!-- table-complete-1.vue -->